import React from 'react'
import { Job, JobWizardMobile } from 'sprockets_react/job_wizards/registries'

JobWizardMobile.MatchedBusiness = {
  onSubmit: function(onStepProgression) {
    onStepProgression()
  },

  onLeftNavButtonClick(onStepProgression) {
    JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.SelectLocation)
  },

  component: React.createClass({
    render: function() {
      return (
        <div className='font-16'>
          <div className='mb20 font-16'>
            Looks like {Job.Data.exclusiveBusiness} - {Job.Data.viewBusinessPhoneNumber} isn't matched to jobs like this.
          </div>
          <div className='mb20 font-14 text-gray'>
            Continue if you'd like to get quotes from local matches.
          </div>
        </div>
      )
    }
  })
}
